// just importing a type so yes we want the import to come from frontend so if things change frontendV2 is notified
// eslint-disable-next-line no-restricted-imports
import { RenderMenuParams } from '../../../frontend/scripts/common/components/FFMenuV2/RenderMenuParams';

//It is expected that if this app is a "v2" app it will automatically get the stand-alone-menu js injected into
// the dom. This means this `renderFFMenu` function will exists on the window object and we can safety call it here
declare const renderMenu: (
    activeMenu: string,
    params: RenderMenuParams
) => void;
//eslint-disable-next-line @typescript-eslint/no-explicit-any
const win = window as any;

export default function () {
    if (!win.hideMenu) {
        renderMenu?.(win.activeMenu, {
            ffmenuBuildVersion: '1',
            currentUser: win.currentUser,
            featureFlags: win.featureFlags,
            notifications: win.notifications,
            serverEnv: win.serverEnv,
            initialize: {
                initializedState: win.initializedNavMenuState,
                navMenuSizeLocked: win.navMenuSizeLocked,
            },
        });
    }
}
